import { useEffect, useState } from "react";
import "./suggestionDropdown.css";
import { useSelector } from "react-redux";
import { userSelector } from "../../../redux/slices/userSlice";

// Reusable dropdown component for suggesting choices dynamically
const SuggestionDropdown = ({
  customstyle,   // Optional custom style for the select element
  onChange,      // onChange handler for form updates
  isDisable,     // Boolean to disable the select field
  id,            // Identifier used to filter dropdown options
  isEdit,        // Edit mode flag
  finaldata,     // Final options to render in edit mode
  formikvalues,  // Current formik form values
}) => {
  const [choice, setChoice] = useState([]);
  const { getChoices } = useSelector(userSelector); // Redux state to access choice options

  // Filters the choice list based on the current dropdown's `id`
  const dropDown = () => {
    const filterData = getChoices.filter(
      (item) => item.choice_type.toLowerCase() === id?.toLowerCase()
    );
    setChoice(filterData);
  };

  // Collects all values from getChoices to validate selected value
  const finalData = getChoices.map((item) => item.value);

  // Re-run the filtering logic whenever `getChoices` changes
  useEffect(() => {
    dropDown();
  }, [getChoices]);

  // Render dropdown for edit mode (uses `finaldata`)
  return isEdit ? (
    <select
      className="suggestionselectcontainer"
      name={id}
      style={customstyle}
      onChange={onChange}
      disabled={isDisable}
    >
      <option value={""}>Choose</option>
      {finaldata?.length > 0 &&
        finaldata?.map((option) => (
          <option
            key={`${option.id}-${option.value}`}
            id={id}
            value={option.value}
            data-id={option.id}
          >
            {option.value}
          </option>
        ))}
    </select>
  ) : (
    // Render dropdown for normal (non-edit) mode using filtered `choice` list
    <select
      className="suggestionselectcontainer"
      name={id}
      style={customstyle}
      onChange={onChange}
      disabled={isDisable}
      value={finalData.includes(formikvalues[id]) ? formikvalues[id] : ""}
    >
      <option value={""}>Choose</option>
      {choice?.length > 0 &&
        choice?.map((option) => (
          <option
            key={`${option.id}-${option.value}`}
            id={id}
            value={option.value}
            data-id={option.id}
          >
            {option.value}
          </option>
        ))}
    </select>
  );
};

export default SuggestionDropdown;
